import script from './SearchableSelect.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box"},[_c('form',{staticClass:"search-form",on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_c('AutoCompleteInput',{attrs:{"placeholder":_vm.placeholder,"areSuggestionsShown":_vm.areSuggestionsShown,"suggestions":_vm.suggestions,"minCharacters":_vm.minSearchCharacters,"isAsync":true,"isIconRight":_vm.isIconRight,"type":"text","data-lpignore":"true","autofocus":_vm.autofocus},on:{"click":_vm.showSuggestions,"itemClick":_vm.handleSubmit,"suggestionsStateChange":_vm.onSuggestionsStateChange},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v;},expression:"query"}})],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-70b131e0_0", { source: ".search-box[data-v-70b131e0]{display:flex;align-items:center;padding:6px 8px;width:100%;background-color:#fff;border-radius:4px}.search-form[data-v-70b131e0]{border:0;padding:0;width:100%}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-70b131e0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
